import { render, staticRenderFns } from "./KanbanLinkBox.vue?vue&type=template&id=a426bbf4&"
import script from "./KanbanLinkBox.vue?vue&type=script&lang=js&"
export * from "./KanbanLinkBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports